//check cookie for currentCohort and use that enrollment if it exists
export const getCookie = (name) => {
    name = name + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            //found the currentCohort cookie
            var cookie = (c.substring(name.length, c.length))
        }
    }
    return cookie;
}
